import { render, staticRenderFns } from "./EditTeamModal.vue?vue&type=template&id=b19fc738&"
import script from "./EditTeamModal.vue?vue&type=script&lang=js&"
export * from "./EditTeamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports